module.exports = __webpack_public_path__ + "static/img/suv-bluegrey.f53ece1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/suv-bluegrey.svg
// module id = sBDj
// module chunks = 74